import React, { useEffect, useRef } from "react";
import { PropTypes } from "prop-types";
import Dropdown from "../../utils/components/Dropdown";
import { default as ProjectsDropdown } from "../../pages/Dashboard/components/Dropdown";
import Logo from "../../static/Logo.svg";
import { AiFillCaretDown } from "react-icons/ai";

import { logout } from "../../utils/redux/auth/authActions";
import { connect, useSelector } from "react-redux";
import { auth } from "../routes";
import { useLocation, useNavigate } from "react-router";

const Header = ({ user, translate, logout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const prevProject = useRef(
    JSON.parse(localStorage.getItem(`project-${user?.id}`)) || null,
  );

  const { project } = useSelector(state => state.app);

  useEffect(() => {
    if (project) {
      if (prevProject?.current?.id !== project?.id) {
        navigate(auth.dashboard.link);
      }

      prevProject.current = project;
    }
  }, [project, navigate]);

  return (
    <header className="header">
      <img className="me-4" width="70px" src={Logo} alt="Logo"/>
      {location.pathname !== "/" && (
        <div className="d-flex align-items-center">
          <ProjectsDropdown/>
        </div>
      )}
      <div className="profile-bar">
        <p className="mb-0 me-3">{user.name}</p>
        <Dropdown
          items={[
            {
              name: translate("header.user.my_account"),
              link: auth.account.link,
            },
            {
              name: translate("logout"),
              onClick: logout,
            },
          ]}
        >
          <AiFillCaretDown className="fs-4"/>
        </Dropdown>
      </div>
    </header>
  );
};

Header.defaultProps = {
  userName: "User",
};

Header.propTypes = {
  userName: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(null, mapDispatchToProps)(Header);
